/**
 * @flow
 */

import React from 'react'
import BaseModalContainer from '../../../commons/BaseModalContainer'
import styles from './styles'
import SuccessFormDesktop from './index.desktop.js'

class BookingResponseMessage extends React.Component<Props> {
  static defaultProps = {
    closeLightBoxCallBack: () => {},
    closeMobileForm: () => {}
  }

  closeLightbox = () => {
    const { closeLightBoxCallBack } = this.props
    this.closeModal()
    document.body.style.overflowY = 'scroll'
    closeLightBoxCallBack()
  }

  closeLightBoxAndCloseMobileFormModal = () => {
    const { closeMobileForm } = this.props
    this.closeLightbox()
    document.body.style.overflowY = 'scroll'
    closeMobileForm()
  }

  captureModalRef = ref => {
    if (ref) {
      this.modalRef = ref
    }
  }

  openModal = () => {
    if (this.modalRef) {
      this.modalRef.openModal()
      document.body.style.overflowY = 'hidden'
    }
  }
  closeModal = () => {
    if (this.modalRef) {
      this.modalRef.closeModal()
    }
    document.body.style.overflowY = 'scroll'
  }

  render() {
    const {
      amanoraSectionDetails,
      bookingResponseData,
      bookingInfo,
      pagePrefix
    } = this.props
    return (
      <BaseModalContainer
        ref={this.captureModalRef}
        hideCloseIcon
        style={styles}
      >
        <SuccessFormDesktop
          closeLightBox={this.closeLightbox}
          amanoraSectionDetails={amanoraSectionDetails}
          bookingResponseData={bookingResponseData}
          bookingInfo={bookingInfo}
          closeLightBoxAndCloseMobileFormModal={
            this.closeLightBoxAndCloseMobileFormModal
          }
          pagePrefix={pagePrefix}
        />
      </BaseModalContainer>
    )
  }
}

export default BookingResponseMessage



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/index.js